module.exports = __webpack_public_path__ + "img/w3_add_dark.54802803.png";